



































import PersonalDataFinancialSponsorForm, {
  PersonalDataFinancialSponsorFormEvent,
} from '@/components/forms/studentData/PersonalDataFinancialSponsorForm.vue';
import PipelineMenu from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import BackButton from '@/components/BackButton.vue';
import pipeline from '@/pipeline';
import Vue from 'vue';

export default Vue.extend({
  components: {
    BackButton,
    BottomButton,
    PersonalDataFinancialSponsorForm,
    PipelineMenu,
  },
  data() {
    return {
      form: {
        cpf: this.$store.getters.personalDataFinancialSponsor?.cpf || '',
        email: this.$store.getters.personalDataFinancialSponsor?.email || '',
        phone: this.$store.getters.personalDataFinancialSponsor?.phone || '',
        fullName: this.$store.getters.personalDataFinancialSponsor?.fullName || '',
        birthDate: this.$store.getters.personalDataFinancialSponsor?.birthDate || '',
      },
      hasErrors: false,
      isContinueDisabled: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      return Object.values(this.form).every(Boolean) && !this.hasErrors;
    },
  },
  methods: {
    async continueHandler(): Promise<void> {
      this.isContinueDisabled = true;
      try {
        await this.$store.dispatch('UPDATE_PERSONAL_DATA_FINANCIAL_SPONSOR', {
          personalDataFinancialSponsor: this.form,
        });
        pipeline.next();
      } finally {
        this.isContinueDisabled = false;
      }
    },
    inputHandler(event: PersonalDataFinancialSponsorFormEvent, hasErrors: boolean) {
      this.hasErrors = hasErrors;
      this.form = event;
    },
  },
});
